import { useState } from 'react';
import translator from '@Components/Utilities/Translator';

const CategoryAccordionPanel = (props) => {

    const [collapsed, setCollapsed] = useState(true);
    const toggleCollapsed = () => setCollapsed(collapsed => !collapsed);

    return (
        <div className={'category-panel-root' + (props.TreeLevel === 1 ? ' root-panel' : '')}>
            <div className={'category-panel-content' + (collapsed ? ' collapsed' : '')}>
                {props.ChildCategories && props.ChildCategories.length > 0 &&
                    <a role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggleCollapsed(); } }} aria-label={collapsed ? translator.translate('sandhills.crm.dscrm.expand') : translator.translate('sandhills.collapse') } className='category-count-expand-button' onClick={toggleCollapsed}>
                        <div className='expand-icon' />
                    </a>}
                <a className={'category-listings-link' + (props.ListingsURL ? '' : ' no-link')} href={props.ListingsURL}>
                    <span className='category-count'>
                        {props.Count}
                    </span>
                    <div className='category-name'>
                        {props.Name}
                    </div>
                </a>
                {!collapsed &&
                    <div className='child-categories-container'>
                        {props.ChildCategories.map(category => <CategoryAccordionPanel {...category} TreeLevel={props.TreeLevel + 1} />)}
                    </div>}
            </div>
        </div>
    );
};

export default CategoryAccordionPanel;